import { ReactNode } from 'react';
import { Stack, Title } from '@mantine/core';

export function Layout({
  title,
  children,
  className
}: {
  title: string;
  children: ReactNode;
  className?: string
}) {
  return (
    <Stack gap="md" p="md" className={className}>
      <Title order={3}>{title}</Title>
      {children}
    </Stack>
  );
}
